import React from "react";
import clsx from "clsx";

import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import {
  getKoraxModeColors,
  koraxTokens
} from "../../designSystem";

const useStyles = makeStyles(theme => {
  const modeColors = getKoraxModeColors(theme.mode);

  return {
    root: {
      margin: 0,
      color: modeColors.textPrimary,
      fontFamily: koraxTokens.typography.fontFamily,
      fontSize: koraxTokens.typography.pageTitleSize,
      fontWeight: koraxTokens.typography.pageTitleWeight,
      lineHeight: 1.2,
      letterSpacing: "-0.02em",

      [theme.breakpoints.down("sm")]: {
        fontSize: 20
      }
    }
  };
});

export default function Title({
  children,
  className,
  component = "h1",
  ...rest
}) {
  const classes = useStyles();

  return (
    <Typography
      component={component}
      className={clsx(classes.root, className)}
      {...rest}
    >
      {children}
    </Typography>
  );
}
